const whatWeOfferData = [
  {
    id: 1,
    title: "Offshore Development",
    description:
      "Outsource your project to the most reliable offshore development company team of designers and developers and we ensure to deliver only top-quality solutions as the end product.",
    detailList: [],
  },
  {
    id: 2,
    title: "Technology Expertise",
    description:
      "A very distinct pool of skilled and certified developers in various languages collectively form the eQuest company.",
    detailList: [],
  },
  {
    id: 3,
    title: "Global Delivery Model",
    description:
      "Having served the multi-domain industries for so many years, we are proud to have continued relationships with clients all across the globe.",
    detailList: [],
  },
  {
    id: 4,
    title: "Support",
    description:
      "End-to-end support not only during the development but also after deployment has helped us retain our clients.",
    detailList: [],
  },
];

export default whatWeOfferData;
